/**
 * This is my google maps API key. Key is needed for frontend to function, can be replaced with another
 * Replacement key should have the appropriate JS and directions API enabled in GCP console
 * NB: This key is restricted, and will necessarily be included in the transpiled build files
 * 
 * It will be necessary to include this file in the final build - it is intentionally git-ignored
 * 
 * Author name:   Rithesh R Jayaram "MolarFox"
 * Student ID:    29687284
 * Last modified: 24-10-2020
 */

export const GMAPS_API_KEY: string = "AIzaSyBkb7M2-KAlddjBYQrmDrh8G6QKmptfEDc";